module.exports = __webpack_public_path__ + "img/curva.f3e6dfaf.svg";